import { TrailerFormName } from '../OrderForm';
import { AccountInformationFieldNames } from './AccountInformationFields';
import { AxleFieldNames, AxleFormName } from './AxleInformationFields';
import { CommentsInformationFieldNames } from './CommentsInformationFields';
import { CompanyAddressFieldNames } from './CompanyAddressFields';
import { CompanyInformationFieldNames } from './CompanyInformationFields';
import { DeliveryAndNotificationInformationFieldNames } from './DeliveryAndNotificationInformationFields';
import { DriverInformationFieldNames } from './DriverInformationFields';
import { InsuranceInformationFieldNames } from './InsuranceInformationFields';
import { JurisdictionIdFieldNames } from './JurisdictionIdFields';
import { LoadInformationFieldNames } from './LoadInformationFields';
import { MobileHomeInformationFieldNames } from './MobileHomeInformationFields';
import { OverallDimensionsInformationFieldNames } from './OverallDimensionsInformationFields';
import {
  TractorAxlesFormName,
  TractorFieldNames,
} from './TractorInformationFields';
import { TrailerFieldNames } from './TrailerInformationFields';
import { TripInformationFieldNames } from './TripInformationFields';

export const permitFieldDisplayOrder = {
  carrierAndPermitDelivery: {
    companyInformation: [
      CompanyInformationFieldNames.CompanyName,
      CompanyInformationFieldNames.DoingBusinessAs,
      CompanyInformationFieldNames.CarrierContactName,
      CompanyInformationFieldNames.CompanyEmail,
      CompanyInformationFieldNames.CompanyPhone,
      CompanyInformationFieldNames.CompanyFax,
    ],
    companyAddress: [
      CompanyAddressFieldNames.CompanyPhysicalAddress,
      CompanyAddressFieldNames.CompanyPhysicalAddressDetails,
      CompanyAddressFieldNames.CompanyPhysicalCity,
      CompanyAddressFieldNames.CompanyPhysicalState,
      CompanyAddressFieldNames.CompanyPhysicalZipCode,
      CompanyAddressFieldNames.CompanyMailingAddress,
      CompanyAddressFieldNames.CompanyMailingAddressDetails,
      CompanyAddressFieldNames.CompanyMailingCity,
      CompanyAddressFieldNames.CompanyMailingState,
      CompanyAddressFieldNames.CompanyMailingZipCode,
    ],
    driverInformation: [
      DriverInformationFieldNames.DriverName,
      DriverInformationFieldNames.DriverEmail,
      DriverInformationFieldNames.DriverPhone,
      DriverInformationFieldNames.DriverLicenseNumber,
    ],
    orderInformation: [
      DeliveryAndNotificationInformationFieldNames.PermitContactName,
      DeliveryAndNotificationInformationFieldNames.PermitContactPhone,
      DeliveryAndNotificationInformationFieldNames.PermitContactEmailAddress,
    ],
    permitDeliveryAndNotifications: [
      DeliveryAndNotificationInformationFieldNames.PrimaryDeliveryType,
      DeliveryAndNotificationInformationFieldNames.SecondaryDeliveryType,
      DeliveryAndNotificationInformationFieldNames.PrimaryDeliveryTypeValue,
      DeliveryAndNotificationInformationFieldNames.SecondaryDeliveryTypeValue,
      DeliveryAndNotificationInformationFieldNames.DriverDeliveryType,
      DeliveryAndNotificationInformationFieldNames.DriverDelivery,
      DeliveryAndNotificationInformationFieldNames.DriverDeliveryName,
      DeliveryAndNotificationInformationFieldNames.DriverDeliverySmsAuthorization,
      DeliveryAndNotificationInformationFieldNames.DriverDeliveryCommunicationFrequency,
    ],
  },
  accountsAndInsurances: {
    account: [AccountInformationFieldNames.Bilingual],
    insuranceInformation: [
      InsuranceInformationFieldNames.InsuranceCompany,
      InsuranceInformationFieldNames.InsuranceAddressNumber,
      InsuranceInformationFieldNames.InsuranceEffectiveDate,
      InsuranceInformationFieldNames.InsuranceExpirationDate,
      InsuranceInformationFieldNames.InsurancePolicyNumber,
      InsuranceInformationFieldNames.InsuranceCoverageAmount,
      InsuranceInformationFieldNames.InsuranceAgentName,
      InsuranceInformationFieldNames.InsurancePhoneNumber,
      InsuranceInformationFieldNames.InsuranceIsOnFileWithState,
    ],
    juridictionIds: [
      JurisdictionIdFieldNames.CaNSC,
      JurisdictionIdFieldNames.AbMVIDNumber,
      JurisdictionIdFieldNames.BcCustomerNumber,
      JurisdictionIdFieldNames.BcFINNumber,
      JurisdictionIdFieldNames.QcNEQNumber,
      JurisdictionIdFieldNames.QcNIRNumber,
      JurisdictionIdFieldNames.OnCVORNumber,
      JurisdictionIdFieldNames.OnPRIOAccountNumber,
      JurisdictionIdFieldNames.NlMasterNumber,
      JurisdictionIdFieldNames.UsICC,
      JurisdictionIdFieldNames.UsIFTA,
      JurisdictionIdFieldNames.UsIRP,
      JurisdictionIdFieldNames.UsDotNumber,
      JurisdictionIdFieldNames.FederalIdNumber,
      JurisdictionIdFieldNames.LaNumber,
      JurisdictionIdFieldNames.KentuckyNumber,
      JurisdictionIdFieldNames.MontanaNumber,
      JurisdictionIdFieldNames.OregonFileNumber,
      JurisdictionIdFieldNames.TennesseeNumber,
      JurisdictionIdFieldNames.TexasNumber,
    ],
  },
  haulingEquipment: {
    tractorInformation: [
      TractorFieldNames.TractorUnitNumber,
      TractorFieldNames.TractorMake,
      TractorFieldNames.TractorVIN,
      TractorFieldNames.TractorYear,
      TractorFieldNames.TractorModelNumber,
      TractorFieldNames.TractorType,
      TractorFieldNames.TractorFuelType,
      TractorFieldNames.TractorBodyStyle,
      TractorFieldNames.VehicleOfSpecialDesign,
      TractorFieldNames.TractorLicensePlateNumber,
      TractorFieldNames.TractorLicensePlateState,
      TractorFieldNames.TractorFloridaVehicleConfiguration,
      TractorFieldNames.TractorOntarioVehicleType,
      TractorFieldNames.TractorAxleCount,
    ],
    tractorDimensions: [
      TractorFieldNames.TractorLegalWeight,
      TractorFieldNames.TractorLength,
      TractorFieldNames.TractorGroundHeight,
      TractorFieldNames.TractorWheelBase,
      TractorFieldNames.TractorWidth,
      TractorFieldNames.TractorHeight,
      TractorFieldNames.TractorUnladenWeight,
      TractorFieldNames.TractorActualWeight,
      TractorFieldNames.TractorGVW,
      TractorFieldNames.TractorOuterBridgeLength,
    ],
    tractorLicense: [
      TractorFieldNames.TractorLicenseEffectiveDate,
      TractorFieldNames.TractorLicenseExpirationDate,
      TractorFieldNames.TractorLicensePlateType,
      TractorFieldNames.TractorLicensePlateYear,
      TractorFieldNames.TractorLicenseIsApportionedPlate,
    ],
    tractorOwner: [
      TractorFieldNames.TractorIsLeased,
      TractorFieldNames.TractorOwnerName,
      TractorFieldNames.OwnerCompanyName,
      TractorFieldNames.USDOTNumberOfOwningCompany,
      TractorFieldNames.OwnerAddress,
      TractorFieldNames.OwnerCity,
      TractorFieldNames.OwnerState,
      TractorFieldNames.OwnerZipCode,
      TractorFieldNames.OwnerPhone,
      TractorFieldNames.OwnerEmail,
    ],
    globalTrailers: [
      TrailerFieldNames.IsDualLane,
      TrailerFieldNames.IsTrunnionAxle,
    ],
    trailers: [
      TrailerFieldNames.TrailerUnitNumber,
      TrailerFieldNames.TrailerYear,
      TrailerFieldNames.TrailerMake,
      TrailerFieldNames.TrailerVIN,
      TrailerFieldNames.TrailerType,
      TrailerFieldNames.TrailerAxleCount,
      TrailerFieldNames.TrailerLicensePlate,
      TrailerFieldNames.TrailerLicensePlateState,
      TrailerFieldNames.TrailerLicensePlateType,
      TrailerFieldNames.TrailerLength,
      TrailerFieldNames.TrailerWidth,
      TrailerFieldNames.TrailerHeight,
      TrailerFieldNames.TrailerWheelbaseLength,
      TrailerFieldNames.TrailerDeckHeight,
      TrailerFieldNames.TrailerGroundClearance,
      TrailerFieldNames.TrailerKingpinSetbackLength,
      TrailerFieldNames.TrailerKingpinSettingLength,
      TrailerFieldNames.TrailerEmptyWeight,
      TrailerFieldNames.TrailerRegisteredWeight,
    ],
  },
  loadInformation: {
    loadInformation: [
      LoadInformationFieldNames.LoadDescription,
      LoadInformationFieldNames.FloridaPermitType,
      LoadInformationFieldNames.FloridaLoadDescription,
      LoadInformationFieldNames.FloridaLoadIdentity,
      LoadInformationFieldNames.Commodity,
      LoadInformationFieldNames.LoadDisposition,
      LoadInformationFieldNames.LoadEndToEndCount,
      LoadInformationFieldNames.LoadHeight,
      LoadInformationFieldNames.LoadIndustryType,
      LoadInformationFieldNames.LoadIsNewlyManufactured,
      LoadInformationFieldNames.LoadIsSingleItem,
      LoadInformationFieldNames.LoadLength,
      LoadInformationFieldNames.LoadLoadingMethod,
      LoadInformationFieldNames.LoadMake,
      LoadInformationFieldNames.LoadModel,
      LoadInformationFieldNames.LoadOwnerAddress,
      LoadInformationFieldNames.LoadOwnerName,
      LoadInformationFieldNames.LoadQuantity,
      LoadInformationFieldNames.LoadSealedContainerChassisNumber,
      LoadInformationFieldNames.LoadSealedContainerNumber,
      LoadInformationFieldNames.LoadSerialNumber,
      LoadInformationFieldNames.LoadSideBySideCount,
      LoadInformationFieldNames.LoadStackCount,
      LoadInformationFieldNames.LoadWeight,
      LoadInformationFieldNames.LoadWidth,
      LoadInformationFieldNames.LoadYear,
    ],
    mobileHome: [
      MobileHomeInformationFieldNames.LoadIsMobileHome,
      MobileHomeInformationFieldNames.IsUsedMobileHome,
      MobileHomeInformationFieldNames.MobileHomeYear,
      MobileHomeInformationFieldNames.MobileHomeMake,
      MobileHomeInformationFieldNames.MobileHomeSerialNumber,
      MobileHomeInformationFieldNames.MobileHomeHitchLength,
      MobileHomeInformationFieldNames.MobileHomeEaveWidth,
      MobileHomeInformationFieldNames.MobileHomeBoxWidth,
      MobileHomeInformationFieldNames.MobileHomeBoxLength,
      MobileHomeInformationFieldNames.MobileHomeRoadsideEavesLength,
      MobileHomeInformationFieldNames.MobileHomeCurbsideEavesLength,
      MobileHomeInformationFieldNames.MobileHomeHudNumber,
    ],
  },
  axlesConfiguration: {
    axles: [
      AxleFieldNames.AxleWeight,
      AxleFieldNames.AxleSpacing,
      AxleFieldNames.TireCount,
      AxleFieldNames.TireRating,
      AxleFieldNames.AxleCapacity,
      AxleFieldNames.AxleWidth,
      AxleFieldNames.AxleType,
      AxleFieldNames.TireSize,
      AxleFieldNames.SuspensionType,
      AxleFieldNames.AxleGroup,
      AxleFieldNames.IsSteeringAxle,
    ],
    overallDimensions: [
      OverallDimensionsInformationFieldNames.OverallLength,
      OverallDimensionsInformationFieldNames.OverallHeight,
      OverallDimensionsInformationFieldNames.OverallWidth,
      OverallDimensionsInformationFieldNames.OverallWeight,
      OverallDimensionsInformationFieldNames.OverallFrontOverhang,
      OverallDimensionsInformationFieldNames.OverallRearOverhang,
      OverallDimensionsInformationFieldNames.OverallEFFOverhang,
    ],
  },
  routingAndStates: {
    globalTrips: [
      TripInformationFieldNames.TripOriginalOrigin,
      TripInformationFieldNames.TripFinalDestination,
    ],
    trips: [
      TripInformationFieldNames.TripOrigin,
      TripInformationFieldNames.TripDestination,
      TripInformationFieldNames.TripBaseRegisteredWeight,
      TripInformationFieldNames.TripRoute,
      TripInformationFieldNames.TripMileage,
      TripInformationFieldNames.EffectiveDate,
      TripInformationFieldNames.TripIncludesReturnTrip,
      TripInformationFieldNames.TripReturnDestination,
      TripInformationFieldNames.TripReturnRoute,
      TripInformationFieldNames.TripReturnMileage,
    ],
  },
  notesAndDocuments: {
    comments: [CommentsInformationFieldNames.Comments],
  },
} as const;

export const nestedContainerFields: Record<string, readonly string[]> = {
  [TrailerFormName]: permitFieldDisplayOrder.haulingEquipment.trailers,
  [AxleFormName]: permitFieldDisplayOrder.axlesConfiguration.axles,
  [TractorAxlesFormName]: permitFieldDisplayOrder.axlesConfiguration.axles,
};

export type PermitCategoryKey = keyof typeof permitFieldDisplayOrder;

export const permitCategoryDisplayOrder = Object.keys(
  permitFieldDisplayOrder,
) as PermitCategoryKey[];

const SPACING_FOR_DYNAMIC_FIELD_RANKING = 2;

const buildFieldDisplayRank = (): Map<string, number> => {
  const rank = new Map<string, number>();
  let sectionIndex = 0;
  for (const sections of Object.values(permitFieldDisplayOrder)) {
    for (const sectionFields of Object.values<readonly string[]>(sections)) {
      for (const field of sectionFields) {
        if (!rank.has(field)) {
          rank.set(field, sectionIndex * SPACING_FOR_DYNAMIC_FIELD_RANKING);
        }
      }
      sectionIndex++;
    }
  }
  for (const [container, leafFields] of Object.entries(nestedContainerFields)) {
    const sectionRank = rank.get(leafFields[0]);
    if (sectionRank !== undefined) {
      rank.set(container, sectionRank);
    }
  }
  return rank;
};

const fieldDisplayRank = buildFieldDisplayRank();

const UNRANKED = Number.MAX_SAFE_INTEGER;

const TRACTOR_AXLES_RANK =
  fieldDisplayRank.get(TractorAxlesFormName) ?? UNRANKED;

const isTrailerAxleField = (field: string) => {
  const fieldsPart = field.split('.');
  if (fieldsPart.length > 3) {
    return fieldsPart[0] === TrailerFormName && fieldsPart[2] === AxleFormName;
  }
  return false;
};

const getFieldRank = (flattenedField: string): number => {
  if (isTrailerAxleField(flattenedField)) {
    return TRACTOR_AXLES_RANK === UNRANKED ? UNRANKED : TRACTOR_AXLES_RANK + 1;
  }
  const [containerOrField] = flattenedField.split('.');
  const rank = fieldDisplayRank.get(containerOrField);
  return rank ?? UNRANKED;
};

export const sortFlattenedFieldsForDisplay = (
  flattenedFields: string[],
): string[] =>
  [...flattenedFields].sort((a, b) => getFieldRank(a) - getFieldRank(b));

const nestedContainerFieldsAsSet = new Set(Object.keys(nestedContainerFields));

export const filterOutContainerFields = (flattenedFields: string[]) =>
  [...flattenedFields].filter(
    (a: string) => !nestedContainerFieldsAsSet.has(a),
  );
